<div class="container" style="background: white !important" *ngIf="home">
  <!-- Left Section -->
  <div class="left-section">
    <div class="centered-content">
      <h2 style="font-style: bold">🚨 Emergency? Stay Calm.</h2>
      <h3 class="tagline">Book an Ambulance Instantly with Vaya Ambulance.</h3>
    </div>
    <img src="../../../../assets/Images/new-images/ambulance-pick.webp" alt="Ambulance" class="ambulance-img" />
  </div>

  <!-- Right Section: Booking Form -->
  <div class="right-section">
    <div id="book_amb" class="modal fade custom-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form [formGroup]="ambulanceForm" (ngSubmit)="proceed()" class="book-consultation-form p-4">
            <div class="modal-header" style="padding: 0px; border: none; padding-bottom: 10px">
              <h4 class="mb-3">Book Ambulance</h4>
            </div>
            <div class="form-group mb-3">
              <label>Select Patient <span class="text-danger">*</span></label>
              <select id="patient-select" class="form-select form-control" formControlName="patient"
                (change)="onPatientChange('ambulance')">
                <option [ngValue]="null" disabled>Select Patient</option>
                <option *ngFor="let patient of patientList" [ngValue]="patient">
                  {{ patient.first_name + " " + patient.last_name }}
                </option>
              </select>

              <div *ngIf="
                  ambulanceForm.get('patient')?.touched &&
                  ambulanceForm.get('patient')?.invalid
                " class="text-danger">
                Patient is required.
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Age <span class="text-danger">*</span></label>

              <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="3" class="form-control"
                formControlName="age" placeholder="Enter Age" (keypress)="blockInvalidKeys($event)"
                (paste)="blockInvalidPaste($event)" (input)="validateAge()" />

              <div *ngIf="ageCtrl?.enabled && ageCtrl?.touched && ageCtrl?.invalid">
                <div *ngIf="ageCtrl?.hasError('required')" class="text-danger">
                  Age is required.
                </div>
                <div *ngIf="ageCtrl?.hasError('min')" class="text-danger">
                  Age must be 18 or above
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Gender <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="gender">
                <option value="" disabled selected>Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('gender')?.touched &&
                  ambulanceForm.get('gender')?.invalid
                " class="text-danger">
                Gender is required.
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Phone Number <span class="text-danger">*</span></label>
              <ngx-intl-tel-input class="custom_imput custom_imput_disabled" [inputId]="'phone-input'"
                [cssClass]="'custom'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false"
                [enablePlaceholder]="false" [searchCountryFlag]="true" [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name,
                ]" [customPlaceholder]="'Enter Phone Number'" [selectFirstCountry]="true"
                [selectedCountryISO]="CountryISO.Zimbabwe" [separateDialCode]="true" [maxLength]="15"
                (input)="onPhoneInput($event)" [phoneValidation]="true" name="phone" formControlName="phone">
              </ngx-intl-tel-input>
              <div *ngIf="ambulanceForm.get('phone')?.touched" class="text-danger mt-1">
                <div *ngIf="ambulanceForm.get('phone')?.errors?.required">
                  Phone Number is required.
                </div>
                <div *ngIf="
                    !ambulanceForm.get('phone')?.errors?.required &&
                    ambulanceForm.get('phone')?.errors?.invalidZimbabweMobile
                  ">
                  Invalid Zimbabwe phone number
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Medical Condition <span class="text-danger">*</span></label>
              <input (keydown)="cleanInput($event)" type="text" placeholder="Enter Medical Condition"
                class="form-control" formControlName="medicalReason" />
              <div *ngIf="
                  ambulanceForm.get('medicalReason')?.touched &&
                  ambulanceForm.get('medicalReason')?.invalid
                " class="text-danger">
                Medical Condition is required.
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Pick-up Location <span class="text-danger">*</span></label>
              <!-- Country -->
              <label>Country <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="pick_country"
                (change)="onCountryChange($event, 'pickup')" autocomplete="new-country">
                <option value="" disabled>Select Country</option>
                <option *ngFor="let c of countryDetails" [value]="c.country_id">
                  {{ c.country_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('pick_country')?.touched &&
                  ambulanceForm.get('pick_country')?.hasError('required')
                " class="text-danger">
                Country is required.
              </div>

              <!-- State -->
              <label class="pick-lable">State / Province <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="pick_state"
                (change)="onStateChange($event, 'pickup')" autocomplete="new-state">
                <option value="" disabled>Select State</option>
                <option *ngFor="let s of pickupStates" [value]="s.state_id">
                  {{ s.state_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('pick_state')?.touched &&
                  ambulanceForm.get('pick_state')?.hasError('required')
                " class="text-danger">
                State / Province is required.
              </div>

              <!-- City -->
              <label class="pick-lable">City <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="pick_city" autocomplete="new-city">
                <option value="" disabled>Select City</option>
                <option *ngFor="let city of pickupCities" [value]="city.city_id">
                  {{ city.city_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('pick_city')?.touched &&
                  ambulanceForm.get('pick_city')?.hasError('required')
                " class="text-danger">
                City is required.
              </div>

              <!-- Address -->
              <label class="pick-lable">Flat No./House No./Building Name
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input type="text" placeholder="Enter Pick-up Address" class="form-control"
                formControlName="buildingPickLocation" maxlength="100" />
              <div class="text-muted small mt-1">
                {{
                ambulanceForm.get("buildingPickLocation")?.value?.length || 0
                }}/100
              </div>

              <div *ngIf="
                  ambulanceForm.get('buildingPickLocation')?.touched &&
                  ambulanceForm.get('buildingPickLocation')?.invalid
                ">
                <!-- <div class="text-danger" *ngIf="ambulanceForm.get('pickLocation')?.errors?.['required']">
                  Address is required.
                </div> -->

                <div class="text-danger" *ngIf="
                    ambulanceForm.get('buildingPickLocation')?.errors?.[
                      'maxlength'
                    ]
                  ">
                  Address cannot exceed 100 characters.
                </div>
              </div>

              <label>Pickup Location <span class="text-danger">*</span></label>

              <input type="text" class="form-control" placeholder="Select pickup location"
                formControlName="pickLocation" readonly (click)="openMap('pickup')" />

              <div *ngIf="
              ambulanceForm.get('pickLocation')?.touched &&
              ambulanceForm.get('pickLocation')?.hasError('required')
            " class="text-danger">
                Pickup Location is required.
              </div>

              <small class="text-success mt-1">
                <span class="use-location" (click)="openMap('pickup')">
                  📍 Use current location
                </span>
              </small>

            </div>

            <div class="form-group mb-3">
              <label>Drop-off Location <span class="text-danger">*</span></label>
              <!-- Country -->
              <label>Country <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="drop_country"
                (change)="onCountryChange($event, 'drop')" autocomplete="new-country">
                <option value="" disabled>Select Country</option>
                <option *ngFor="let c of countryDetails" [value]="c.country_id">
                  {{ c.country_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('drop_country')?.touched &&
                  ambulanceForm.get('drop_country')?.hasError('required')
                " class="text-danger">
                Country is required.
              </div>

              <!-- State -->
              <label class="pick-lable">State / Province <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="drop_state"
                (change)="onStateChange($event, 'drop')" autocomplete="new-state">
                <option value="" disabled>Select State</option>
                <option *ngFor="let s of dropStates" [value]="s.state_id">
                  {{ s.state_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('drop_state')?.touched &&
                  ambulanceForm.get('drop_state')?.hasError('required')
                " class="text-danger">
                State / Province is required.
              </div>

              <!-- City -->
              <label class="pick-lable">City <span class="text-danger">*</span></label>
              <select class="form-select form-control" formControlName="drop_city" autocomplete="new-city">
                <option value="" disabled>Select City</option>
                <option *ngFor="let city of dropCities" [value]="city.city_id">
                  {{ city.city_name }}
                </option>
              </select>
              <div *ngIf="
                  ambulanceForm.get('drop_city')?.touched &&
                  ambulanceForm.get('drop_city')?.hasError('required')
                " class="text-danger">
                City is required.
              </div>

              <!-- Address -->
              <label class="pick-lable">Flat No./House No./Building Name
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input type="text" placeholder="Enter Drop-off Address" class="form-control"
                formControlName="buildingDropLocation" maxlength="100" />
              <div class="text-muted small mt-1">
                {{
                ambulanceForm.get("buildingDropLocation")?.value?.length || 0
                }}/100
              </div>

              <div *ngIf="
                  ambulanceForm.get('buildingDropLocation')?.touched &&
                  ambulanceForm.get('buildingDropLocation')?.invalid
                " class="text-danger">
                <!-- <div class="text-danger" *ngIf="ambulanceForm.get('dropLocation')?.errors?.['required']">
                  Address is required.
                </div> -->
                <div class="text-danger" *ngIf="
                    ambulanceForm.get('buildingDropLocation')?.errors?.[
                      'maxlength'
                    ]
                  ">
                  Address cannot exceed 100 characters.
                </div>
              </div>

              <label>Dropoff Location <span class="text-danger">*</span></label>
              <input type="text" class="form-control" placeholder="Select drop-off location"
                formControlName="dropLocation" readonly (click)="openMap('drop')" />
            </div>

            <div *ngIf="
              ambulanceForm.get('dropLocation')?.touched &&
              ambulanceForm.get('dropLocation')?.hasError('required')
            " class="text-danger">
              Dropoff Location is required.
            </div>

            <div class="text-danger same-address mt-2" *ngIf="
    ambulanceForm.errors?.['sameAddress'] &&
    (ambulanceForm.touched || ambulanceForm.dirty)
  ">
              Pick-up and Drop-off address cannot be the same.
            </div>

            <div class="form-group custom-center">
              <button type="submit" class="add-new-btn book_btn button_class">
                Book Ambulance
              </button>
              <button type="button" id="book" class="d-none" data-bs-dismiss="modal"></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="payment-summary" *ngIf="proceedToPay">
  <div class="summary-box">
    <h2>Summary</h2>
    <p>
      <strong>Name:</strong>
      {{
      paymentStatus?.patient?.first_name +
      " " +
      paymentStatus?.patient?.last_name ||
      "Not
      available"
      }}
    </p>
    <p>
      <strong>Number:</strong> +263 {{ paymentStatus?.patient?.phone || "N/A" }}
    </p>
    <p>
      <strong>Date:</strong>
      {{
      paymentStatus?.booking_date
      ? (paymentStatus?.booking_date | date: "dd/MM/yy")
      : "Not
      selected"
      }}
    </p>
    <p>
      <strong>Time:</strong>
      {{
      paymentStatus?.booking_date
      ? (paymentStatus?.booking_date | date: "shortTime")
      : "Not
      set"
      }}
    </p>
    <p>
      <strong>Medical condition:</strong>
      {{ paymentStatus?.medicalReason || "N/A" }}
    </p>
    <p>
      <strong>Pick-up location:</strong>
      {{ paymentStatus?.pickLocation || "Unknown" }}
    </p>
    <p>
      <strong>Drop-off location:</strong>
      {{ paymentStatus?.dropLocation || "Unknown" }}
    </p>

    <div class="button-group">
      <button class="btn back" (click)="back()">Back</button>
      <button class="btn confirm button_class" (click)="onBookingAmbulance()">
        Confirm
      </button>
    </div>
  </div>
</div>

<div class="booking-success" *ngIf="bookingConfirmed">
  <div class="success-box">
    <img src="../../../../assets/img/check-mark-removebg-preview.png" alt="Success" class="success-icon" />
    <h2>Booking successful</h2>
    <p>Our Ambulance agent will contact you shortly!!</p>
    <button class="btn done button_class" (click)="goToHome()">Okay</button>
  </div>
</div>

<div class="map-overlay" *ngIf="showMap">
  <div class="map-box">
    <div class="map-header">
      <h5>Select Location</h5>
      <button type="button" class="btn-close" aria-label="Close map" (click)="closeMap()"></button>
    </div>

    <div class="map-body">
      <div class="map-loader" *ngIf="isMapLoading">
        <div class="spinner-border text-primary"></div>
        <p>Loading map...</p>
      </div>
      <div id="map" class="map-container"></div>
    </div>

    <div class="map-footer">
      <button *ngIf="mapMode === 'select'" type="button" class="btn button_class w-100 no-hover"
        (click)="confirmLocation()">
        Confirm Location
      </button>

      <button *ngIf="mapMode === 'route'" type="button" class="btn button_class w-100 no-hover"
        (click)="confirmAndBook()">
        Confirm &amp; Book
      </button>
    </div>
  </div>
</div>